<template>
  <member-form
    v-show="showMemberForm"
    ref="memberForm"
    :embedded-in-model-table="false"
    simplify
    @apply-changes="memberFormApplyChanges()"
    @add-model="memberFormApplyChanges()"
  />

  <div
    v-if="user"
    class="q-mt-md q-mb-md"
    style="width: 100%; max-width: 800px; margin-left: auto; margin-right: auto;"
  >
    <q-inner-loading
      v-if="user.loading"
      :showing="true"
    />
    <template v-else>
      <div
        class="col-auto text-label text-left text-h6 q-px-sm"
        :class="$q.screen.lt.sm ? 'q-my-sm' : 'q-my-md'"
      >
        {{ $t('pages.activitySelectTickets.titles.greeting', { name: order.user.firstName, membershipTypesAvailable }) }}
        <span class="text-negative">{{ activity.hasMinimumAttendance ? $t('pages.activitySelectTickets.titles.messages.minimumAttendanceRequired', { minimumAttendance: activity.minimumAttendance }) : '' }}</span>
      </div>
      <div
        class="text-h6 text-left bg-grey-4"
        :class="$q.screen.lt.sm ? 'q-pa-sm' : 'q-pa-md'"
      >
        {{ $tc(membershipTypesAvailable ? 'ticket.memberTicket' : 'ticket.ticket', 2) }}
      </div>
      <div
        v-if="activity.loading"
        class="full-width items-center text-center q-list q-list--bordered q-list--separator"
      >
        <q-spinner size="lg" />
      </div>
      <q-list
        v-else-if="userOrderDatas.user"
        bordered
        separator
        style="full-width"
        :class="$register ? undefined : 'bg-white'"
      >
        <q-item
          v-for="userOrderData in $_.concat([userOrderDatas.user], $_.values(userOrderDatas.members))"
          :key="userOrderData.user.id"
          :class="{
            'text-grey': !areTicketsAllowed,
            'q-px-sm': $q.screen.lt.sm
          }"
        >
          <template v-if="userOrderData.ticketTypeOrItemPackage">
            <q-item-section
              v-if="showMemberImages && $register"
              avatar
            >
              <q-img
                class="self-center"
                :src="userOrderData.user.photoUrl"
                :ratio="1"
                height="102px"
                width="102px"
              />
            </q-item-section>
            <q-item-section :style="showMemberImages || $q.screen.lt.lg ? 'min-height: 70px;' : 'height: 62px;'">
              <div :class="$q.screen.lt.sm ? 'column' : 'row q-gutter-x-xs justify-between'">
                <div
                  class="column items-start justify-center col"
                >
                  <div
                    class="items-center justify-center"
                  >
                    <span
                      class="ellipsis text-subtitle2"
                      :class="$q.screen.xs ? 'q-mx-xs' : undefined"
                      :style="{
                        'font-size': $q.screen.xs ? '1.1rem': '1.2rem',
                        'max-width': $q.screen.xs ? '60px': '100px',
                        'line-height': $q.screen.xs ? '1.275rem': '1.375rem'
                      }"
                    >
                      {{ userOrderData.user.firstName !== '' ? userOrderData.user.firstName : userOrderData.user.name }}
                    </span>
                    <div
                      class="row justify-center text-uppercase"
                    >
                      <template v-if="$q.screen.gt.xs && (user && user.id) === userOrderData.user.id && (user.dayPassDate || order.purchasingDayPass)">
                        <q-chip
                          class="ellipsis q-ma-none"
                          square
                          dense
                          color="primary"
                          text-color="white"
                          :label="$t('person.dayPassHolder')"
                        />
                      </template>
                      <template v-else-if="$q.screen.gt.xs && userOrderData.user.membership && !userOrderData.user.membershipType.hide && ( $register || userOrderData.user.membership.state === 'active')">
                        <q-chip
                          class="ellipsis q-mx-none"
                          style="max-width: 115px;"
                          square
                          dense
                          :disable="userOrderData.user.type === USER_TYPES.GUEST && !currentCircuit.allowGuests"
                          :color="userOrderData.user.membership.state === 'active' ? 'primary' : null"
                          :text-color="userOrderData.user.membership.state === 'active' ? 'white' : null"
                          :label="(userOrderData.user.membershipType && userOrderData.user.membershipType.name) + (!!userOrderData.user.membershipTier ? (' - ' + userOrderData.user.membershipTier.name) : '')"
                        />
                        <q-icon
                          v-if="userOrderData.user.membership.state !== 'active' && $register"
                          name="cancel"
                          size="sm"
                          color="negative"
                        />
                      </template>
                    </div>
                  </div>
                </div>
                <div
                  class="col column  justify-center"
                  :class="$q.screen.lt.lg ? 'items-start' : 'items-center'"
                >
                  <q-chip
                    v-if="$_.concat(userOrderData.memberTicketTypes, userOrderData.memberItemPackages).length <= 1"
                    class="ellipsis q-px-xs"
                    square
                  >
                    {{ userOrderData.ticketTypeOrItemPackage.displayName || userOrderData.ticketTypeOrItemPackage.name }}
                  </q-chip>
                  <q-select
                    v-else
                    class="full-width"
                    :class="$q.screen.xs ? 'q-mt-sm q-mb-md' : undefined"
                    :model-value="userOrderData.ticketTypeOrItemPackage.displayName || userOrderData.ticketTypeOrItemPackage.name"
                    :options="$_.concat(userOrderData.memberTicketTypes, userOrderData.memberItemPackages)"
                    :disable="activityBooking.isUserTicketTypeOrItemPackageSelected(userOrderData)"
                    dense
                    filled
                    :label="$t('pages.activitySelectTickets.labels.viewTicketOptions')"
                    :hint="$q.screen.gt.xs ? $t('pages.activitySelectTickets.messages.numTicketTypesAvailable', { count: $_.concat(userOrderData.memberTicketTypes, userOrderData.memberItemPackages).length }) : undefined"
                    @update:model-value="ticketTypeOrItemPackage => userOrderData.ticketTypeOrItemPackage = ticketTypeOrItemPackage"
                  >
                    <template #option="scope">
                      <q-item
                        v-bind="scope.itemProps"
                        v-on="scope.itemEvents"
                      >
                        <q-item-section>
                          {{ scope.opt.typeName === 'ItemPackage' ? scope.opt.name : scope.opt.displayName }}
                        </q-item-section>
                      </q-item>
                    </template>
                  </q-select>
                </div>
              </div>
            </q-item-section>
            <q-item-section
              side
              :top="$q.screen.lt.sm"
              :class="{ 'q-mt-sm': $q.screen.lt.sm }"
            >
              <div
                class="row justify-between text-dark"
                :style="{ 'min-width': minWidth }"
              >
                <div
                  class="col column justify-center"
                  :class="$q.screen.lt.lg ? 'items-end q-pr-sm' : 'items-center q-pl-md q-pr-lg'"
                >
                  <div class="text-body1">
                    <div
                      class="text-weight-bolder text-uppercase"
                      :style="{
                        'font-size': $q.screen.xs ? '1.15rem': '1.2rem',
                        'line-height': $q.screen.xs ? '1.15rem': '1.25rem'
                      }"
                    >
                      From
                      <i18n-n
                        :value="activityBooking.getFromPrice(userOrderData.ticketTypeOrItemPackage)"
                        format="currency"
                        scope="global"
                      />
                    </div>
                  </div>
                </div>
                <div
                  class="col-auto column items-center justify-center"
                  style="min-width: 50px; width: 100%;"
                  :style="{ 'max-width': $q.screen.lt.sm ? '98px' : '108px' }"
                >
                  <q-btn
                    v-if="!activityBooking.isTicketLimitReached || !activityBooking.isUserTicketTypeOrItemPackageSelected(userOrderData)"
                    class="col-auto row items-center"
                    style="max-width: 108px; min-width: 50px;"
                    :style="{ width: $q.screen.lt.lg ? undefined : '100%' }"
                    :label="!areTicketsAllowed || (activityBooking.isTicketLimitReached && !activityBooking.isUserTicketTypeOrItemPackageSelected(userOrderData)) ? $t('pages.activitySelectTickets.labels.unavailable') : activityBooking.isUserTicketTypeOrItemPackageSelected(userOrderData) ? $t('pages.activitySelectTickets.labels.remove') : $t('pages.activitySelectTickets.labels.add')"
                    :square="$register"
                    :rounded="!$register"
                    text-color="dark"
                    :color="areTicketsAllowed || (!activityBooking.isTicketLimitReached && activityBooking.isUserTicketTypeOrItemPackageSelected(userOrderData)) && !$register ? 'grey-2' : undefined"
                    :outline="areTicketsAllowed || (!activityBooking.isTicketLimitReached && activityBooking.isUserTicketTypeOrItemPackageSelected(userOrderData)) && $register"
                    :flat="!areTicketsAllowed || (activityBooking.isTicketLimitReached && !activityBooking.isUserTicketTypeOrItemPackageSelected(userOrderData))"
                    :disable="!areTicketsAllowed || (activityBooking.isTicketLimitReached && !activityBooking.isUserTicketTypeOrItemPackageSelected(userOrderData))"
                    @click.stop="activityBooking.isUserTicketTypeOrItemPackageSelected(userOrderData)
                      ? decrement(userOrderData.ticketTypeOrItemPackage, userOrderData.user)
                      : increment(userOrderData.ticketTypeOrItemPackage, userOrderData.user)"
                  >
                    <q-tooltip
                      v-if="activityBooking.isTicketLimitReached"
                      :offset="[10, 10]"
                    >
                      {{ $t('pages.activitySelectTickets.messages.maxCapacityReached') }}
                    </q-tooltip>
                  </q-btn>
                  <q-item-label
                    v-else
                    class="d-flex justify-around"
                  >
                    <q-btn
                      class="col-auto q-px-xs"
                      icon="fal fa-trash-can"
                      color="grey-2"
                      text-color="dark"
                      round
                      @click.stop="decrement(userOrderData.ticketTypeOrItemPackage, userOrderData.user)"
                    />

                    <q-chip
                      color="white"
                      flat
                      square
                      :size="$q.screen.lt.sm ? 'md' : 'lg'"
                    >
                      1
                    </q-chip>
                  </q-item-label>
                </div>
              </div>
            </q-item-section>
          </template>
        </q-item>
      </q-list>
      <div
        v-if="$consumer && redeemableVoucherTypes.length > 0 && currentUser"
        class="text-caption text-center q-mt-sm"
      >
        <div
          class="text-bold text-primary"
        >
          {{ currentUser.points }} {{ currentCircuit.rewardsCurrencyName }}
          <q-icon
            style="margin-bottom: 2px;"
            name="info"
          >
            <q-tooltip>
              <span
                v-for="(voucherType, index) in redeemableVoucherTypes"
                :key="voucherType.id"
              >
                <br v-if="index !== 0">{{ voucherType.name + ' (' + voucherType.pointsCost + ' ' + currentCircuit.rewardsCurrencyName + ')' }}
              </span>
            </q-tooltip>
          </q-icon>
        </div>
        <span>{{ $t('checkout.redeemCurrencyPrompt', { rewardsCurrencyName: currentCircuit.rewardsCurrencyName }) }}.</span>
      </div>
    </template>
  </div>

  <component
    :is="((currentSite.consumerConfig.collapseOtherTickets && $consumer) || (currentSite.collapseOtherTickets && !$consumer)) && order.user ? 'q-expansion-item' : 'div'"
    v-if="user || currentSite.allowAnonymousOrders"
    v-model="expand"
    class="q-mb-md"
    style="width: 100%; max-width: 800px; margin-left: auto; margin-right: auto;"
  >
    <div
      v-if="!(((currentSite.consumerConfig.collapseOtherTickets && $consumer) || (currentSite.collapseOtherTickets && !$consumer)) && order.user)"
      class="text-h6 text-left bg-grey-4"
      :class="$q.screen.lt.sm ? 'q-pa-sm' : 'q-pa-md'"
    >
      {{ order.user ? $t('pages.activitySelectTickets.titles.additionalTickets'): $tc('ticket.ticket', 2) }}
      <div v-if="!$register && activity.loading">
        <q-spinner />
      </div>
    </div>
    <template #header>
      <div
        class="text-h6 text-left"
        :class="$q.screen.lt.sm ? 'q-pa-sm' : 'q-pa-md'"
      >
        {{ $t('pages.activitySelectTickets.titles.additionalTickets') }}
      </div>
    </template>
    <div v-if="activity.loading">
      <q-spinner />
    </div>
    <q-list
      bordered
      separator
      style="full-width"
      :class="$register ? undefined : 'bg-white'"
    >
      <div
        v-if="activityBooking.guestTicketTypesOrItemPackages.length === 0"
        class="q-mt-md q-mb-md text-subtitle2 justify-center row"
      >
        {{ $t('pages.activitySelectTickets.messages.noTicketsAvailable') }}
      </div>
      <q-item
        v-for="ticketTypeOrItemPackage in activityBooking.guestTicketTypesOrItemPackages"
        :key="getKeyForTicketTypeOrItemPackage(ticketTypeOrItemPackage)"
        :class="{ 'q-px-sm': $q.screen.lt.sm }"
      >
        <q-item-section>
          <div class="row">
            <div
              v-if="isItemPackage(ticketTypeOrItemPackage)"
              class="col column items-start justify-center"
            >
              <div
                class="text-subtitle2"
                style="font-size: 1rem;"
              >
                {{ ticketTypeOrItemPackage.name }}
              </div>
              <div
                class="text-grey-7 text-subtitle"
                style="font-size: 13px;"
              >
                <div
                  v-for="ticketType in ticketTypeOrItemPackage.ticketTypeDescriptions"
                  :key="ticketType.id"
                >
                  {{ `${ticketType.description} (${$tc('ticket.activityTicket', 1)})` }}
                </div>
                <div
                  v-for="itemVariation in ticketTypeOrItemPackage.itemVariationDescription"
                  :key="itemVariation.id"
                >
                  {{ itemVariation.name }}
                </div>
              </div>
            </div>
            <div
              v-else
              class="col column items-start justify-center"
            >
              <div
                class="row items-center justify-center q-gutter-x-xs"
              >
                <span
                  class="text-subtitle2"
                  style="font-size: 1rem;"
                >
                  {{ ticketTypeOrItemPackage.displayName }}
                </span>
                <q-icon
                  v-if="ticketTypeOrItemPackage.userClass"
                  style="font-size: 16px; padding-bottom: 2px;"
                  name="info"
                  size="xs"
                  color="grey"
                >
                  <q-tooltip>
                    {{ ticketTypeOrItemPackage.userClass.description || ticketTypeOrItemPackage.userClass.ageDescription }}
                  </q-tooltip>
                </q-icon>
              </div>
            </div>
          </div>
        </q-item-section>

        <q-item-section
          side
          :class="{ 'q-mt-sm': $q.screen.lt.sm }"
        >
          <div
            class="row justify-between text-dark"
            :style="{ 'min-width': minWidth }"
          >
            <div
              class="col column justify-center"
              :class="$q.screen.lt.lg ? 'items-end q-pr-sm' : 'items-center q-pl-md q-pr-lg'"
            >
              <div class="text-body1">
                <div
                  class="text-weight-bolder text-uppercase"
                  :style="{
                    'font-size': $q.screen.xs ? '1.15rem': '1.2rem',
                    'line-height': $q.screen.xs ? '1.15rem': '1.25rem'
                  }"
                >
                  From
                  <i18n-n
                    :value="activityBooking.getFromPrice(ticketTypeOrItemPackage)"
                    format="currency"
                    scope="global"
                  />
                </div>
              </div>
            </div>
            <div
              class="col-auto row justify-center items-end"
              :style="{ 'min-width': $q.screen.lt.lg ? '98px' : '108px' }"
            >
              <q-btn
                v-if="!activityBooking.isGuestTicketTypeOrItemPackageSelected(ticketTypeOrItemPackage) || activity.maxActivitySpaceCapacity === 1"
                class="col-auto row items-center"
                style="max-width: 108px; min-width: 50px;"
                :style="{ width: $q.screen.lt.lg ? undefined : '100%' }"
                :label="!areTicketsAllowed || (activityBooking.isTicketLimitReached && !activityBooking.isGuestTicketTypeOrItemPackageSelected(ticketTypeOrItemPackage)) ? $t('pages.activitySelectTickets.labels.unavailable') : (activityBooking.isTicketLimitReached && activityBooking.isGuestTicketTypeOrItemPackageSelected(ticketTypeOrItemPackage)) ? $t('pages.activitySelectTickets.labels.remove') : $t('pages.activitySelectTickets.labels.add')"
                :square="$register"
                :rounded="!$register"
                text-color="dark"
                :color="areTicketsAllowed || (!activityBooking.isTicketLimitReached && activityBooking.isGuestTicketTypeOrItemPackageSelected(ticketTypeOrItemPackage)) && !$register ? 'grey-2' : undefined"
                :outline="areTicketsAllowed || (!activityBooking.isTicketLimitReached && activityBooking.isGuestTicketTypeOrItemPackageSelected(ticketTypeOrItemPackage)) && $register"
                :flat="!areTicketsAllowed || (activityBooking.isTicketLimitReached && !activityBooking.isGuestTicketTypeOrItemPackageSelected(ticketTypeOrItemPackage))"
                :disable="!areTicketsAllowed || (activityBooking.isTicketLimitReached && !activityBooking.isGuestTicketTypeOrItemPackageSelected(ticketTypeOrItemPackage))"
                @click.stop="(activityBooking.isTicketLimitReached && activityBooking.isGuestTicketTypeOrItemPackageSelected(ticketTypeOrItemPackage))
                  ? decrement(ticketTypeOrItemPackage)
                  : increment(ticketTypeOrItemPackage)"
              />
              <template v-else>
                <q-btn
                  class="col-auto"
                  :class="{ 'text-grey': !activityBooking.isGuestTicketTypeOrItemPackageSelected(ticketTypeOrItemPackage) }"
                  :icon="activityBooking.guestTicketTypeOrItemPackageQuantity(ticketTypeOrItemPackage) === 1 ? 'fal fa-trash-can' : 'fal fa-minus'"
                  dense
                  square
                  outline
                  :disable="!activityBooking.isGuestTicketTypeOrItemPackageSelected(ticketTypeOrItemPackage)"
                  @click.stop="decrement(ticketTypeOrItemPackage)"
                />
                <div
                  class="col-auto text-h5 q-px-md"
                >
                  {{ activityBooking.guestTicketTypeOrItemPackageQuantity(ticketTypeOrItemPackage) }}
                </div>
                <q-btn
                  class="col-auto"
                  :class="{ 'text-grey': activityBooking.isTicketLimitReached }"
                  icon="fal fa-plus"
                  dense
                  square
                  outline
                  :disable="activityBooking.isTicketLimitReached"
                  @click.stop="increment(ticketTypeOrItemPackage)"
                >
                  <q-tooltip
                    v-if="activityBooking.isTicketLimitReached"
                    :offset="[10, 10]"
                  >
                    {{ $t('pages.activitySelectTickets.messages.maxCapacityReached') }}
                  </q-tooltip>
                </q-btn>
              </template>
            </div>
          </div>
        </q-item-section>
      </q-item>
    </q-list>
  </component>

  <div
    v-if="activityBooking.guestTicketTypesOrItemPackages.length > 0 && activity.sessionAdmissionType !== SESSION_ADMISSION_TYPES.SESSION && activity.maxConsecutiveActivityUnits > 1"
    class="q-mb-md"
    style="width: 100%; max-width: 800px; margin-left: auto; margin-right: auto;"
  >
    <div
      class="text-h6 text-left bg-grey-4"
      :class="$q.screen.lt.sm ? 'q-pa-sm' : 'q-pa-md'"
    >
      {{ $_.startCase(activity.activityUnitDescriptionPlural) }}
    </div>
    <div
      v-if="activity.loading"
      class="full-width items-center text-center q-list q-list--bordered q-list--separator"
    >
      <q-spinner size="lg" />
    </div>
    <q-list
      bordered
      separator
      style="full-width"
      :class="$register ? undefined : 'bg-white'"
    >
      <q-item>
        <div class="full-width">
          <div class="row">
            <div
              class="col column items-start justify-center"
            >
              <div
                class="row items-center justify-center q-gutter-x-xs"
              >
                <span
                  class="text-subtitle2"
                  style="font-size: 1rem;"
                >
                  {{ $_.startCase(activity.activityUnitDescription) }}
                </span>
              </div>
            </div>
            <div
              class="col-auto row justify-center items-center"
            >
              <q-btn
                class="col-auto"
                :class="{ 'text-grey': activityBooking.activityUnitQuantity <= 1 }"
                icon="fal fa-minus"
                dense
                square
                outline
                :disable="activityBooking.activityUnitQuantity <= 1"
                @click.stop="activityBooking.decrementActivityUnitQuantity()"
              />
              <div
                class="col-auto text-h5 q-px-md"
              >
                {{ activityBooking.activityUnitQuantity }}
              </div>
              <q-btn
                class="col-auto"
                :class="{ 'text-grey': activityBooking.activityUnitQuantity >= activity.maxConsecutiveActivityUnits }"
                icon="fal fa-plus"
                dense
                square
                outline
                :disable="activityBooking.activityUnitQuantity >= activity.maxConsecutiveActivityUnits"
                @click.stop="activityBooking.incrementActivityUnitQuantity()"
              />
            </div>
          </div>
        </div>
      </q-item>
    </q-list>
  </div>
</template>

<script>
import { SESSION_ADMISSION_TYPES } from 'src/models/activity/Activity'
import ActivityBooking from 'src/models/activity/ActivityBooking'
import { USER_TYPES } from 'src/models/user/User'
import MemberForm from 'src/modules/register/membership/MemberForm'
import { watchEffect } from 'vue'

export default {
  name: 'ActivitySelectTickets',
  components: { MemberForm },
  inject: ['order', 'checkoutData'],
  props: {
    activityBooking: {
      type: ActivityBooking,
      required: true
    }
  },
  context: ['currentUser'],
  configuration: ['currentSite', 'currentCircuit', 'membershipTypes', 'voucherTypes'],
  data () {
    return {
      editingUser: null,
      showMemberForm: false,
      userOrderDatas: {},
      expand: false
    }
  },
  computed: {
    areTicketsAllowed () {
      return !this.currentSite.membershipRequired || (this.user?.membership?.effective && this.user?.unlimitedMembershipTicketVoucherTypes.length > 0)
    },
    membershipTypesAvailable () {
      return !!_.find(this.membershipTypes.data, membershipType => {
        return !membershipType.default && !membershipType.hide && membershipType.availableOnline
      })
    },
    minWidth () {
      if (this.$kiosk) return '300px'
      if (this.$q.screen.xs) return '170px'
      if (this.$q.screen.lt.lg) return '200px'
      return '300px'
    },
    redeemableVoucherTypes () {
      return _.sortBy(_.filter(this.voucherTypes.data, voucherType => {
        return voucherType.isReward && voucherType.pointsCost <= this.currentUser.points
      }), 'pointsCost')
    },
    showMemberImages () {
      return this.$register && this.user && _(this.userOrderDatas.member).values().every(({ user }) => user.hasPhoto)
    },
    activity () {
      return this.activityBooking.activity
    },
    user () {
      return this.order.user
    }
  },
  watch: {
    'activity.loading' () {
      if (this.activity?.loading === false) {
        this.computeUserOrderDatas()
      }
    },
    'user.loading' () {
      if (this.user?.loading === false) {
        this.computeUserOrderDatas()
      }
    }
  },
  created () {
    _.extend(this, { SESSION_ADMISSION_TYPES, USER_TYPES })
  },
  mounted () {
    this.computeUserOrderDatas()

    if (_.isNil(this.checkoutData)) return

    this.stopWatch = watchEffect(() => {
      this.checkoutData.showLoading = this.loading
      this.checkoutData.purchasingMembership = false

      this.checkoutData.stepTitle = this.activity.name
      this.checkoutData.showActivityCard = true
      this.checkoutData.showCartControls = true
      this.checkoutData.showCheckoutFooter = true

      this.checkoutData.expandDefault = false
      this.checkoutData.expandConcessions = false
      this.checkoutData.expandTickets = true

      this.checkoutData.infoTitle = this.$i18n.t('checkout.infoTitles.tickets')
      this.checkoutData.info = this.$i18n.tc('ticket.ticketCount', this.order.activityTicketOrderItems.length)
      this.checkoutData.showInfo = true
      this.checkoutData.showSubtotal = true
      this.checkoutData.showTotals = false

      this.checkoutData.showEmptyCartNextLabel = true

      this.checkoutData.canProceed = this.activityBooking.areMinimumAttendanceRequirementsMet
    })
  },
  unmounted () {
    this.stopWatch?.()
  },
  methods: {
    computeUserOrderDatas () {
      if (this.user?.loading === false && this.activity.loading === false) {
        this.userOrderDatas = this.order.getTicketTypesAndItemPackagesForUserAndPurchasableMembers(
          this.user,
          this.activity,
          this.activityBooking.activityTicketOrderItems
        )
      } else {
        this.userOrderDatas = {}
      }
    },
    decrement (ticketTypeOrItemPackage, user) {
      this.activityBooking.decrement(ticketTypeOrItemPackage, user)
    },
    getKeyForTicketTypeOrItemPackage (ticketTypeOrItemPackage) {
      return `${ticketTypeOrItemPackage.constructor.name}-${ticketTypeOrItemPackage.id}`
    },
    increment (ticketTypeOrItemPackage, user) {
      if (user?.type === USER_TYPES.GUEST && !this.currentCircuit.allowGuests) {
        this.editingUser = user
        this.$refs.memberForm.show(user)
        this.showMemberForm = true
        return
      }

      this.activityBooking.increment(ticketTypeOrItemPackage, user)
    },
    isItemPackage (ticketTypeOrItemPackage) {
      return ticketTypeOrItemPackage.constructor.name === 'ItemPackage'
    },
    memberFormApplyChanges () {
      this.editingUser.save()
      this.showMemberForm = false
    }
  }
}
</script>
